/**
 * The facts the legal pages state about who is behind the service.
 *
 * Separate from `brand.ts` because these are not branding. A rebrand changes
 * the name on the door; changing the operating entity, the governing law or the
 * address that receives copyright notices is a different event with different
 * consequences, and burying those in a components file means somebody edits
 * them by accident or fails to edit them at all.
 *
 * Everything here is read by `TermsPage` and `PrivacyPage` and nowhere else.
 * Change it here and both documents follow.
 */
export const legal = {
  /**
   * The entity users are contracting with.
   *
   * Set this to the registered company once one exists - it is the difference
   * between an agreement with a business and an agreement with a person.
   */
  operator: import.meta.env.VITE_LEGAL_OPERATOR ?? 'Vibed',

  /** Where disputes are heard, and whose consumer law applies. */
  jurisdiction: import.meta.env.VITE_LEGAL_JURISDICTION ?? 'the Commonwealth of Kentucky, USA',

  /** Reads as a date rather than a version number, because people check dates. */
  effective: import.meta.env.VITE_LEGAL_EFFECTIVE ?? '27 August 2026',

  /**
   * The addresses each kind of message should go to.
   *
   * Distinct because they have different urgency and different readers: a
   * copyright notice starts a clock, a privacy request has a statutory deadline,
   * and general support is neither.
   */
  contact: {
    support: import.meta.env.VITE_SUPPORT_EMAIL ?? 'support@getvibed.live',
    privacy: import.meta.env.VITE_PRIVACY_EMAIL ?? 'privacy@getvibed.live',
    copyright: import.meta.env.VITE_COPYRIGHT_EMAIL ?? 'copyright@getvibed.live',
  },

  /** How long a copyright strike counts, matching `DiscoveryCredits`' sibling in `DmcaRepository`. */
  strikeMonths: 6,
} as const;
